import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    getPartnerNotifications,
    getNotificationStats,
    getNotificationById,
    markNotificationAsRead,
    markAllNotificationsAsRead,
    deleteNotification
} from '../api/notifications';

// Query Keys
export const notificationKeys = {
    all: ['partner-notifications'],
    list: (params) => [...notificationKeys.all, 'list', params],
    stats: () => [...notificationKeys.all, 'stats'],
    detail: (id) => [...notificationKeys.all, 'detail', id],
};

// Get Partner Notifications
export const useGetPartnerNotifications = (params = {}) => {
    return useQuery({
        queryKey: notificationKeys.list(params),
        queryFn: () => getPartnerNotifications(params),
        staleTime: 30000, // 30 seconds
        retry: 2,
    });
};

// Get Notification Stats
export const useGetNotificationStats = () => {
    return useQuery({
        queryKey: notificationKeys.stats(),
        queryFn: getNotificationStats,
        staleTime: 30000, // 30 seconds
        retry: 2,
    });
};

// Get Notification by ID
export const useGetNotificationById = (id) => {
    return useQuery({
        queryKey: notificationKeys.detail(id),
        queryFn: () => getNotificationById(id),
        enabled: !!id,
        staleTime: 30000,
        retry: 2,
    });
};

// Mark Notification as Read
export const useMarkNotificationAsRead = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: markNotificationAsRead,
        onSuccess: () => {
            // Invalidate and refetch notifications
            queryClient.invalidateQueries({ queryKey: notificationKeys.all });
        },
    });
};

// Mark All Notifications as Read
export const useMarkAllNotificationsAsRead = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: markAllNotificationsAsRead,
        onSuccess: () => {
            // Invalidate and refetch notifications
            queryClient.invalidateQueries({ queryKey: notificationKeys.all });
        },
    });
};

// Delete Notification
export const useDeleteNotification = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteNotification,
        onSuccess: () => {
            // Invalidate and refetch notifications
            queryClient.invalidateQueries({ queryKey: notificationKeys.all });
        },
    });
};
